export type DynamicMessage = string;

export const getWelcomeDirectAppointmentActivateErrorMessage = (
  carrierName: string,
): DynamicMessage =>
  `There was a problem while updating your direct appointments. Please check that your ${carrierName} credentials are correct and try again.`;
